import { CheckCircle, AlertCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const STAT_CARDS = [
  {
    key: "inserted",
    label: "Yeni Eklendi",
    bg: "bg-green-50",
    border: "border-green-200",
    text: "text-green-600",
    sub: "text-green-700",
  },
  {
    key: "updated",
    label: "Güncellendi",
    bg: "bg-blue-50",
    border: "border-blue-200",
    text: "text-blue-600",
    sub: "text-blue-700",
  },
  {
    key: "total_errors",
    label: "Hata",
    bg: "bg-red-50",
    border: "border-red-200",
    text: "text-red-600",
    sub: "text-red-700",
  },
];

/**
 * Displays the result of an Excel import operation.
 * Props: result ({message, inserted, updated, total_errors, errors[]}), onReset (fn)
 */
export function ImportResult({ result, onReset }) {
  const navigate = useNavigate();
  const [showErrors, setShowErrors] = useState(false);
  const openCard = (key) => {
    if (key === "inserted" && result.modul === "stoklar" && result.inserted_ids?.length) {
      navigate(`/stoklar?imported=${result.inserted_ids.join(",")}`);
    }
    if (key === "total_errors" && result.total_errors > 0) setShowErrors((value) => !value);
  };
  const downloadErrors = () => {
    if (!result.errors?.length) return;
    const rows = ["Hata", ...result.errors].map((value) => `"${String(value).replace(/"/g, '""')}"`);
    const blob = new Blob([`\uFEFF${rows.join("\n")}`], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "aktarim-hatalari.csv";
    link.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-6 space-y-4">
      <div className="flex items-center gap-3">
        {result.total_errors === 0 ? (
          <CheckCircle size={24} className="text-green-500" />
        ) : (
          <AlertCircle size={24} className="text-amber-500" />
        )}
        <div>
          <h2 className="font-semibold text-slate-800">{result.message}</h2>
          {result.total_errors > 0 && (
            <p className="text-sm text-amber-600">{result.total_errors} hata oluştu</p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {STAT_CARDS.map(({ key, label, bg, border, text, sub }) => (
          <button type="button" key={key} onClick={() => openCard(key)}
            disabled={(key === "inserted" && (result.modul !== "stoklar" || !result.inserted_ids?.length)) || key === "updated" || (key === "total_errors" && !result.total_errors)}
            className={`${bg} border ${border} rounded-lg p-4 text-center disabled:cursor-default enabled:hover:shadow-md enabled:hover:-translate-y-0.5 transition-all`}>
            <div className={`text-2xl font-bold ${text}`}>{result[key]}</div>
            <div className={`text-xs ${sub} font-medium mt-1`}>{label}</div>
          </button>
        ))}
      </div>

      {showErrors && result.errors?.length > 0 && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <div className="mb-2 flex items-center justify-between gap-3"><p className="text-xs font-semibold text-red-700">Hatalar ({result.errors.length} ayrıntı):</p><button onClick={downloadErrors} className="rounded border border-red-300 bg-white px-2 py-1 text-xs font-semibold text-red-700">CSV İndir</button></div>
          {result.errors.map((e, i) => (
            <p key={`err-${i}`} className="text-xs text-red-600">
              {e}
            </p>
          ))}
        </div>
      )}

      <button
        onClick={onReset}
        className="bg-[#0D1B3E] text-white rounded-md px-5 py-2 text-sm font-medium hover:bg-[#172A58] transition-colors"
      >
        Yeni Aktarım
      </button>
    </div>
  );
}
